import axios from 'axios'
import React from 'react'
import { baseUrl, baseUrl2 } from '../../config/clientsConfig';

const teamServices = {

    createGeoLocationTeam : async (teamData) => {
        return await axios.post(`${baseUrl}/team/geo-location`, teamData);
    },
    updateGeoLocationTeam : async (teamId, teamData) => {
        return await axios.put(`${baseUrl}/team/geo-location/${teamId}`, teamData);
    },
    getGeoLoactionTeams : async (body) => {
        return await axios.post(`${baseUrl}/teams/geo-location` , body);
    },
    getGeoLocationTeamId : async (teamId) => {
        return await axios.get(`${baseUrl}/team/geo-location/${teamId}`);
    },
    // getGeoLocationTeamList : async () => {
    //     return await axios.get(`${baseUrl}/teams-name/geo-location`);
    // },
    getGeoLocationTeamList : async () => {
        return await axios.get(`${baseUrl2}/teams-names-list`);
    },
    getGeoLocationTeamMembers : async (teamId) => {
        return axios.get(`${baseUrl2}/teams/${teamId}/members`);
    }

}

export default teamServices